import Swiper from 'swiper';
import {A11y, Navigation, Pagination, Autoplay} from 'swiper/modules';

window.Swiper = Swiper;

function initTraditionalSwiper(): void {
    const swiperEl = document.querySelector<HTMLElement>('.traditional-slider');
    if (!swiperEl) return;

    const prevEl = '.swiper-arrow-prev';
    const nextEl = '.swiper-arrow-next';

    new Swiper(swiperEl, {
        modules: [Navigation, A11y],
        spaceBetween: 10,
        slidesPerView: 1,
        navigation: {
            prevEl,
            nextEl,
        },
    });
}

function initReviewsSwiper(): void {
    const swiperEl = document.querySelector<HTMLElement>('.reviews-swiper');
    if (!swiperEl) return;

    const prevEl = '.swiper-arrow-prev';
    const nextEl = '.swiper-arrow-next';

    new Swiper(swiperEl, {
        modules: [Navigation, A11y],

        navigation: {
            prevEl,
            nextEl,
        },
        breakpoints: {
            320: {
                spaceBetween: 12,
                slidesPerView: 1,
            },
            767: {
                spaceBetween: 12,
                slidesPerView: 2,
            },
            1280: {
                spaceBetween: 20,
                slidesPerView: 2,
            }
        }
    });
}

export function initSwiper() {
    initTraditionalSwiper();
    initReviewsSwiper();
}